<!-- @format -->

<template>
  <div :class="['inline-block', { 'w-full': block }]" v-bind="$attrs">
    <Button :label="label ? label : 'Exportar'" primary icon="fa-solid fa-arrow-up-from-bracket" @click="exporter(api + '/exporter', name)" :disabled="disabled" :block="block" />
    <TheLoader v-if="loader" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { getFile } from '@/crud.js'
import { useFormat } from '@/composables/useFormat.js'

const { formatFilenameTimestamp } = useFormat()

// Props
const props = defineProps({
  api: String,
  name: String,
  filters: Object,
  disabled: Boolean,
  label: String,
  block: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:filters'])

const loader = ref(false)

//  Methods
const exporter = async (url, filename) => {
  try {
    const reportUrl = url
    loader.value = true
    const query = {
      params: {},
    }
    if (props.filters && props.filters.length > 0) {
      query.params.filters = props.filters
    } else if (props.filters && !Array.isArray(props.filters)) {
      query.params.filters = props.filters
    }

    const fileNameWithTimestamp = `${filename}_${formatFilenameTimestamp()}`
    await getFile(query.params, fileNameWithTimestamp, null, null, reportUrl)
    loader.value = false
  } catch (error) {
    console.log(error)
  }
}
</script>
